import React, { createContext, Component, PureComponent } from 'react';
import { createCache } from './Cache';
import type { SessionCacheType } from './types';

const SessionCacheContext = createContext<SessionCacheType | null>(null);
SessionCacheContext.displayName = 'SessionCacheContext';

/**
 * 会话缓存
 */
export class SessionCache extends PureComponent implements SessionCacheType {
  static displayName = 'SessionCache';

  private cache: SessionCacheType | null = null;

  clear(): void {
    this.cache?.clear();
  }

  remove(key: string): void {
    this.cache?.remove(key);
  }

  get<T>(key: string): T | undefined {
    return this.cache?.get(key);
  }

  set<T>(key: string, value: T): void {
    this.cache?.set(key, value);
  }

  render() {
    return (
      <SessionCacheContext.Consumer>
        {value => {
          this.cache = value;
          return null;
        }}
      </SessionCacheContext.Consumer>
    );
  }
}

/**
 * 会话缓存容器
 */
export class SessionCacheContainer extends Component {
  static displayName = 'SessionCacheContainer';
  private readonly cache = createCache();
  render() {
    return <SessionCacheContext.Provider value={this.cache}>{this.props.children}</SessionCacheContext.Provider>;
  }
}
